import AddHealthcareCompany from "@features/clinics/pages/AddHealthcareCompany";
import ClinicWrapper from "@features/clinics/components/ClinicWrapper";
import PatientList from "@features/clinic-patients/clinic/components/PatientList";
import PatientDetails from "@features/clinic-patients/clinic/components/PatientDetail/PatientDetail";
import Perks from "@features/clinics/pages/perks/components/Perks";
import PatientProperties from "@features/clinic-patients/clinic/components/DataManagement/PatientProperties";
import ImportConfiguration from "@features/clinic-patients/clinic/components/ImportPatients/ImportConfiguration";
import { TagsPage } from "@features/clinic-patients/clinic/components/Tags/TagsPage";
import { AppModeSelector } from "@shared/ui";
import { EntityList } from "@shared/ui";
import { NotYetPlannedPage } from "@shared/ui";
import { ProtectedRoute } from "@shared/ui";
import useNavigateToEntity from "@shared/hooks/navigation/useNavigateToEntity";
import { CLINIC_ROUTES, ROOTS } from "@app/config/constants";
import { findClinicByPath } from "@shared/lib";
import { EntityType, HealthcareCompanyType } from "@shared/types/commonTypes";
import { Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ClinicListRoute = () => {
  const { t } = useTranslation();
  const { navigateToEntity } = useNavigateToEntity({
    rootPath: ROOTS.CLINIC,
    lastVisitedKey: "__LAST_VISITED_C_ID",
    findEntityByPath: findClinicByPath,
  });
  return (
    <EntityList
      entityType={EntityType.CLINIC}
      title={t("clinicList.title")}
      addNewLabel={t("clinicList.addNew")}
      queryKey={["healthcare-companies", HealthcareCompanyType.DENTAL_CLINIC]}
      rootPath={ROOTS.CLINIC}
      lastVisitedKey="__LAST_VISITED_C_ID"
      navigateToEntity={navigateToEntity}
    />
  );
};

export default function ClinicRoutes() {
  return (
    <>
      <Route
        path={`${ROOTS.CLINIC}`}
        element={
          <ProtectedRoute>
            <ClinicListRoute />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROOTS.CLINIC}/add`}
        element={
          <ProtectedRoute>
            <AddHealthcareCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROOTS.CLINIC}/:clinicId`}
        element={
          <ProtectedRoute>
            <ClinicWrapper />
          </ProtectedRoute>
        }
      >
        <Route index element={<NotYetPlannedPage />} />
        <Route path={CLINIC_ROUTES.PATIENTS} element={<PatientList />} />
        <Route path={CLINIC_ROUTES.PATIENTS_TAGS} element={<TagsPage />} />
        <Route
          path={CLINIC_ROUTES.PATIENTS_PROCEDURES}
          element={<NotYetPlannedPage />}
        />
        <Route
          path={CLINIC_ROUTES.PATIENTS_TREATMENT_PLANS}
          element={<NotYetPlannedPage />}
        />
        <Route
          path={CLINIC_ROUTES.PATIENTS_MEDICATIONS}
          element={<NotYetPlannedPage />}
        />
        <Route
          path={CLINIC_ROUTES.PATIENTS_DOCUMENTS}
          element={<NotYetPlannedPage />}
        />
        <Route
          path={CLINIC_ROUTES.PATIENTS_DATA_MANAGEMENT}
          element={<PatientProperties />}
        />
        <Route path={CLINIC_ROUTES.PATIENT_DETAILS} element={<PatientDetails />} />
        <Route
          path={CLINIC_ROUTES.APPOINTMENTS}
          element={<NotYetPlannedPage />}
        />
        <Route
          path={CLINIC_ROUTES.STATISTICS}
          element={<NotYetPlannedPage />}
        />
        <Route path={CLINIC_ROUTES.MINI_SITE} element={<NotYetPlannedPage />} />
        <Route path={CLINIC_ROUTES.PAYMENTS} element={<NotYetPlannedPage />} />
        <Route path={CLINIC_ROUTES.WORKFLOWS} element={<NotYetPlannedPage />} />
        <Route path={CLINIC_ROUTES.PERKS} element={<Perks />} />
        <Route
          path={CLINIC_ROUTES.PATIENT_IMPORT_CONFIG}
          element={<ImportConfiguration />}
        />
        <Route path="*" element={<AppModeSelector />} />
      </Route>
    </>
  );
}
